import { useConnection, useWallet } from '@solana/wallet-adapter-react'
import { LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js'
import classNames from 'classnames'
import Decimal from 'decimal.js'
import millify from 'millify'
import Image from "next/legacy/image"
import { useEffect, useState, useCallback } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect, ConnectedProps, useSelector } from 'react-redux'
import _ from 'underscore'
//@ts-ignore
import ushCoin from '../assets/coins/ush-white.svg'
//@ts-ignore
import hdgCoin from '../assets/coins/hdg-white.svg'
import { numberWithCommas } from '../lib/Utils'
import VaultSystemState from '../on-chain/accounts/VaultSystemState'
import VaultType from '../on-chain/accounts/VaultType'
import { HedgeProgram, HEDGE_PROGRAM_PUBLICKEY } from '../on-chain/utils/HedgeConstants'
import { NetworkConnection } from '../on-chain/utils/NetworkConnections'
import { Collateral, GetUsdcMint } from '../on-chain/utils/OracleAccounts'
import { CollateralTotals } from '../on-chain/utils/SummaryInfo'
import { RootState } from '../pages/_app'
import InfoHover from './InfoHover'
import { debounce } from 'lodash'

const debouncedLoadPsmAccount = debounce(
  async (connection, usdcMint, Wallet, setLoadedPsmAccount) => {
    const enc = new TextEncoder();
    const [psmAccountKey] = await PublicKey.findProgramAddress(
      [enc.encode(usdcMint.toString().slice(0, 12)), enc.encode('PSM')],
      HEDGE_PROGRAM_PUBLICKEY
    );

    const program = HedgeProgram(connection, Wallet);
    const psmAccount = await program.account.psmAccount.fetch(psmAccountKey);
    setLoadedPsmAccount(psmAccount);
    console.log('psmAccount.Overview', psmAccount);
  },
  10000 // 10 seconds
);

const OverviewBar: React.FC<OverviewBarProps> = () => {
  const [loadedPsmAccount, setLoadedPsmAccount] = useState<any>()
  const [expanded, setExpanded] = useState(false)
  // const { connection } = useConnection()
  // const { publicKey: userWalletPublicKey } = useWallet()
  // const Wallet = useWallet()
  const recentPrices = useSelector((state: RootState) => state.wallet.recentPrices)
  // const hdgPrice = useSelector((state: RootState) => state.wallet.hdgPrice)
  const ushPrice = useSelector((state: RootState) => state.wallet.ushPrice)
  const vaultTypes = useSelector((state: RootState) => state.wallet.vaultTypes) as VaultType[]
  const vaultSystemState = useSelector(
    (state: RootState) => state.wallet.vaultSystemState
  ) as VaultSystemState

  const { connection } = useConnection()
  const { publicKey: userWalletPublicKey, wallet } = useWallet()
  const Wallet = useWallet()

  // Sum up all the collateral totals
  const collateralAmountTotals = CollateralTotals(vaultTypes)

  const networkConnection = useSelector(
    (state: RootState) => state.wallet.networkConnection
  ) as NetworkConnection
  const usdcMint = GetUsdcMint(networkConnection)




  let solLockedValue = '(loading)'
  let usdSolPrice = '(loading)'
  if (recentPrices.get(Collateral.SOL) && collateralAmountTotals[Collateral.SOL]) {
    usdSolPrice = recentPrices.get(Collateral.SOL).toFixed(2)
    solLockedValue = numberWithCommas(
      collateralAmountTotals[Collateral.SOL] * recentPrices.get(Collateral.SOL),
      2
    )
  }

  // let usdHdgPrice = '(loading)'
  // if (hdgPrice) {
  //   usdHdgPrice = `${numberWithCommas(hdgPrice, 2)}`
  // }
  let usdUshPrice = '(loading)'
  if (ushPrice) {
    usdUshPrice = `${numberWithCommas(ushPrice, 4)}`
  }
  let usdMSolPrice = '(loading)'
  if (recentPrices.get(Collateral.MSOL) && collateralAmountTotals[Collateral.MSOL]) {
    usdMSolPrice = recentPrices.get(Collateral.MSOL).toFixed(2)
  }

  let totalUshSupply = '(loading)'
  let totalVaults = '(loading)'
  let totalVaultsOpened = '(loading)'
  let totalVaultsClosed = '(loading)'
  if (vaultSystemState) {
    totalUshSupply = `${numberWithCommas(
      vaultSystemState.totalUshSupply.div(LAMPORTS_PER_SOL).toNumber(),
      2
    )} USH`
    totalUshSupply = `${millify(vaultSystemState.totalUshSupply.div(LAMPORTS_PER_SOL).toNumber(), {
      precision: 2,
    })} USH`
    totalVaultsOpened = `${numberWithCommas(vaultSystemState.totalVaults.toNumber(), 0)}`
    totalVaultsClosed = `${numberWithCommas(vaultSystemState.totalVaultsClosed.toNumber(), 0)}`
    totalVaults = `${numberWithCommas(
      vaultSystemState.totalVaults.toNumber() - vaultSystemState.totalVaultsClosed.toNumber(),
      0
    )}`
  }

  let anyNotFound = false
  const collateralValues = Object.keys(collateralAmountTotals).map((collateralType) => {
    if (recentPrices.get(collateralType)) {
      return collateralAmountTotals[collateralType] * recentPrices.get(collateralType)
    }
    anyNotFound = true
    return 0
  })

  let systemCollateralRatio = '(loading)'
  let totalCollateralValue = _.reduce(
    collateralValues,
    (currentTotal, collateralValue) => {
      return currentTotal + collateralValue
    },
    0
  )

  if (vaultSystemState && totalCollateralValue > 0 && loadedPsmAccount) {
    const amountPsmMinted = new Decimal(loadedPsmAccount.amountMinted.toString()).div(
      LAMPORTS_PER_SOL
    )
    systemCollateralRatio =
      numberWithCommas(
        (totalCollateralValue /
          vaultSystemState.totalUshSupply.div(LAMPORTS_PER_SOL).sub(amountPsmMinted).toNumber()) *
        100
      ) + '%'
  }

  let totalSolCollateral = '(loading)'
  if (collateralAmountTotals[Collateral.SOL]) {
    totalSolCollateral = `${numberWithCommas(collateralAmountTotals[Collateral.SOL])}  SOL`
  }

  let allTotals = [<div key="foo">{'(loading)'}</div>]
  let stringTotals = _.map(collateralAmountTotals, (total, collateral) => {
    return `${collateral}: ${numberWithCommas(total as number)}`
  })
  if (stringTotals.length > 0) {
    allTotals = stringTotals.map((content) => {
      return (
        <div className="text-start" key={content.toString()}>
          {content}
        </div>
      )
    })
  }

  const renderMain = () => {
    return (
      <>
        <div>
          <div className="h5 fw-bold mb-0 text-number">
            <Image src={'/solana-white.svg'} width={16} height={16} alt="Solana Coin" /> $
            {usdSolPrice}
          </div>
          <div className="text-muted">SOL Price</div>
        </div>
        {/*<div className="divider d-none d-lg-block" />
        <div className="d-none d-lg-block">
          <div className="h5 fw-bold mb-0 text-number">
            <Image src={hdgCoin} width={16} height={16} alt="Solana Coin" /> ${usdHdgPrice}
          </div>
          <div className="text-muted">HDG Price</div>
        </div> */}
        <div className="divider" />
        <div>
          <div className="h5 fw-bold mb-0 text-number">
            <Image src={ushCoin} width={16} height={16} alt="Solana Coin" /> $
            {usdUshPrice}
          </div>
          <div className="text-muted">USH Price</div>
        </div>
        <div className="divider d-none d-md-block" />
        <div className="d-none d-md-block">
          <div className="h5 fw-bold mb-0 text-number">
            <Image src={ushCoin} width={16} height={16} alt="Solana Coin" /> {totalUshSupply}
          </div>
          <div className="text-muted">Total Supply</div>
        </div>
        <div className="divider d-none d-sm-block" />
        <div className='d-none d-sm-block'>
          <div className="h5 fw-bold mb-0">
            <Image src={'/solana-white.svg'} width={16} height={16} alt="Solana Coin" />{' '}
            {totalSolCollateral}
          </div>
          <div className="text-muted">
            Total Collateral <InfoHover text={<>{allTotals}</>} />
          </div>
        </div>
        <div className="divider" />
        <div>
          <div className="h5 fw-bold mb-0 text-number">
            $
            {millify(totalCollateralValue, {
              precision: 2,
            })}{' '}
          </div>
          <div className="text-muted">
            <span className="">Total Collateral Value</span>
          </div>
        </div>
        <div className="divider d-none d-lg-block" />
        <div className="d-none d-lg-block">
          <div className="h5 fw-bold mb-0">{totalVaults}</div>
          <div className="text-muted">
            Active Vaults{' '}
            <InfoHover
              text={
                <>
                  <div>Total Vaults Opened: {totalVaultsOpened}</div>
                  <div>Total Vaults Closed: {totalVaultsClosed}</div>
                </>
              }
            />
          </div>
        </div>
        {/* <div className="divider d-none d-xl-block" /> 
        <div className="d-none d-xl-block">
          <div className="h5 fw-bold mb-0">{systemCollateralRatio} </div>
          <div className="text-muted">
            System Collateral Ratio{' '}
            <InfoHover
              text={
                <>
                  <div>Total System Collateral</div>
                  <i className="fa-thin fa-divide me-2 fa-lg" />
                  <div>Total System Debt</div>
                </>
              }
            />
          </div>
            </div> */}
      </>
    )
  }
  const renderRows = () => {
    return (
      <>
        <Row className="mb-3 text-muted small">
          <Col>Collateral / Price</Col>
          <Col className="text-end">Vault Type</Col>
          <Col className="text-end">Current Ratio</Col>
          <Col className="text-end">
            Recovery Mode Price{' '}
            <InfoHover text={'The price at which the Total Collateral Ratio for this Vault Type will enter Recovery Mode and allow vaults below the system ratio to be liquidated'} />
          </Col>
          <Col className="text-end">Total Collateral</Col>
          <Col className="text-end">Total Debt</Col>
        </Row>
        {vaultTypes
          .filter((vaultType) => {
            return vaultType.displayInUI
          })
          .map((vaultType) => {
            return (
              <div key={vaultType.name}>
                <VaultTypeRow vaultType={vaultType} />
              </div>
            )
          })}
        <PsmRow />
      </>
    )
  }

  return (
    <div className="container-md px-0 mb-3">
      <div className="hedge-overview-bar rounded px-2 px-sm-3 px-lg-5 py-4">
        <div className="d-flex justify-content-around justify-content-lg-between text-center">
          {renderMain()}
        </div>
      </div>
      <div className="d-none d-sm-block">
        {expanded && (
          <div
            className={classNames('mx-3 my-0', {
              'p-4 pb-2': expanded,
              'p-2': !expanded,
            })}
            style={{
              backgroundColor: 'rgba(42, 38, 48, 0.25)',
            }}
          >
            <div className="">{expanded && renderRows()}</div>
          </div>
        )}
        <div
          className={classNames('text-muted text-center mx-3 mt-0 cursor-pointer', {
            'expand-drawer': !expanded,
          })}
          style={{
            backgroundColor: 'rgba(42, 38, 48, 0.45)',
            borderRadius: '0 0 10px 10px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setExpanded(!expanded)
          }}
        >
          <div className="text-light text-muted small py-1">
            {expanded ? (
              <>
                <i className="me-2 fa-light fa-angles-up"></i>
                {' Show Less '}
                <i className="ms-2 fa-light fa-angles-up"></i>
              </>
            ) : (
              <>
                <i className="me-2 fa-light fa-angles-down"></i>
                {' Show More '}
                <i className="ms-2 fa-light fa-angles-down"></i>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state: RootState) {
  const { vaultTypes, vaultSystemState } = state.wallet
  return {
    // vaultTypes,
    // vaultSystemState,
  }
}

const connector = connect(mapStateToProps)
type OverviewBarProps = ConnectedProps<typeof connector>

export default connector(OverviewBar)

function VaultTypeRow({ vaultType }) {
  const recentPrices = useSelector((state: RootState) => state.wallet.recentPrices)

  let vaultTypeRatio = '(loading)'
  let collateralPrice = '(loading)'
  let collateralValue = '(loading)'
  let recoveryDelta = '(loading)'
  if (recentPrices.get(vaultType.collateral)) {
    const price = recentPrices.get(vaultType.collateral)
    collateralPrice = numberWithCommas(price, 2)
    vaultTypeRatio = vaultType.displayCurrentCollateralRatio(price)
    collateralValue =
      '$' +
      numberWithCommas(
        vaultType.collateralHeld.div(vaultType.lamportsPerCollateralUnit).mul(price),
        0
      )
    recoveryDelta = vaultType.hasRecoveryMode() ? numberWithCommas(price - vaultType.getRecoveryPrice(), 2) + " USD Away" : ''
  }

  return (
    <Row className="mb-3">
      <Col>
        <div className="d-flex">
          <div className="me-3">
            <Image
              alt="Coin Image"
              src={`/crypto-logos/${vaultType.collateralIcon}`}
              width={40}
              height={40}
              className="rounded-circle"
              layout="fixed" // you can use different layouts like 'responsive', 'fill', etc.
            />
          </div>
          <div>
            <div>{vaultType.collateral}</div>
            <div className="text-muted small">
              $<span className="text-number">{collateralPrice}</span>
            </div>
          </div>
        </div>
      </Col>
      <Col className="text-end">{vaultType.title}</Col>
      <Col className="text-end">
        <div className="text-number">{vaultTypeRatio}</div>
        {vaultType.hasRecoveryMode()
          ? <div className="text-muted small">Recovery {vaultType.displayEmergencyThreshold()}</div>
          : ''
        }
      </Col>
      <Col className="text-end">
        <div className="text-number">{vaultType.displayRecoveryPrice()}</div>
        <div className="text-muted small">{recoveryDelta}</div>
      </Col>
      <Col className="text-end">
        <div>
          <span className="text-number">
            {numberWithCommas(vaultType.collateralHeld.div(vaultType.lamportsPerCollateralUnit))}
          </span>{' '}
          {vaultType.collateral}
        </div>
        <div className="text-muted small text-number">{collateralValue}</div>
      </Col>
      <Col className="text-end">
        <span className="text-number">
          {numberWithCommas(vaultType.getTotalDebtExtended().div(LAMPORTS_PER_SOL))}
        </span>{' '}
        USH
      </Col>
    </Row>
  )
}
function PsmRow() {
  const [loadedPsmAccount, setLoadedPsmAccount] = useState<any>()
  const recentPrices = useSelector((state: RootState) => state.wallet.recentPrices)

  const { connection } = useConnection()
  const { publicKey: userWalletPublicKey, wallet } = useWallet()
  const Wallet = useWallet()

  const networkConnection = useSelector(
    (state: RootState) => state.wallet.networkConnection
  ) as NetworkConnection
  const usdcMint = GetUsdcMint(networkConnection)

  // Memoize LoadPsmAccount to prevent it from changing unnecessarily
  const LoadPsmAccount = useCallback(() => {
    // Call the debounced function with all required dependencies
    debouncedLoadPsmAccount(connection, usdcMint, Wallet, setLoadedPsmAccount);
  }, [connection, usdcMint, Wallet]); // Ensure these dependencies are stable

  // Use effect to call LoadPsmAccount
  useEffect(() => {
    LoadPsmAccount();

    // Cleanup function to cancel the debounced call if component unmounts
    return () => {
      debouncedLoadPsmAccount.cancel();
    };
  }, [LoadPsmAccount]);

  let deposited = loadedPsmAccount
    ? new Decimal(loadedPsmAccount.deposited.toString()).div(1000000)
    : new Decimal(0)
  let mintedUsh = loadedPsmAccount
    ? new Decimal(loadedPsmAccount.amountMinted.toString()).div(LAMPORTS_PER_SOL)
    : new Decimal(0)

  return (
    <Row className="mb-3">
      <Col>
        <div className="d-flex">
          <div className="me-3">
            <Image
              alt="Coin Image"
              src="/crypto-logos/usdc.svg"
              width={40}
              height={40}
              className="rounded-circle"
            />
          </div>
          <div>
            <div>USDC</div>
            <div className="text-muted small">
              $<span className="text-number">1.00</span>
            </div>
          </div>
        </div>
      </Col>
      <Col className="text-end">Peg Stability Module</Col>
      <Col className="text-end">
        <div className="text-number">100%</div>
      </Col>
      <Col className="text-end">
        Never
      </Col>
      <Col className="text-end">
        <div>
          <span className="text-number">{numberWithCommas(deposited, 2)}</span>
          {' USDC'}
        </div>
        <div className="text-muted small text-number">${numberWithCommas(deposited, 2)}</div>
      </Col>
      <Col className="text-end">
        <span className="text-number">{numberWithCommas(mintedUsh, 2)}</span> USH
      </Col>
    </Row>
  )
}
